import React from "react";
import { StageWrapper } from "../StyledComponents";
import {
  RenderHeadboard,
  RenderLegs,
  RenderOttoman,
  RenderAddOn,
  RenderTopper,
  RenderTable,
  SafeImage} from "../renderers";
import { legOffsets, bedOffsets, specialOffsets } from "./Data";

// Helper functions
const isTableType = (table, type) => 
  table?.toLowerCase().includes(type.toLowerCase());

const calculateBaseOffset = (bed, legH, bedOffsets, legOffsets) => {
  let offset = 0;
  if (bed in legOffsets && legH in legOffsets[bed]) {
    offset += legOffsets[bed][legH];
  }
  return offset;
};

const calculateHeightOffset = (bed, height, bedOffsets) => {
  let offset = 0;
  if (bed in bedOffsets && height in bedOffsets[bed]) {
    offset += bedOffsets[bed][height];
  }
  return offset;
};

export const get_offsets = (selected, type, extra = false) => {
  const bed = selected.bed.slug;
  const height = selected.bed?.height;
  const legH = selected.legs?.height;
  const table = selected?.bedsidetable?.title;
  let offset = 0;

  switch (type) {
    case "bed":
      offset = calculateBaseOffset(bed, legH, bedOffsets, legOffsets);
      break;

    case "tableLamp": {
      if (isTableType(table, "charon") || isTableType(table, "eicon") || isTableType(table, "plania")) {
        offset -= 0.5;
      }
      
      if (isTableType(table, "add-on floor")) {
        offset += 2;
      } else if (isTableType(table, "add-on")) {
        offset += 5;
      }

      if (isTableType(table, "eicon wall")) {
        offset -= 0.5;
        if (extra) offset += 0.5;
      }
      break;
    }

    case "topper":
    case "tray":
    case "pocket": {
      offset = calculateBaseOffset(bed, legH, bedOffsets, legOffsets);
      offset += calculateHeightOffset(bed, height, bedOffsets);
      
      if (type !== "topper") {
        const specialType = type === "pocket" ? "sub_mat" : type;
        if (bed in specialOffsets[specialType]) {
          offset += specialOffsets[specialType][bed];
        }
      }
      break;
    }

    case "table": {
      if (bed in specialOffsets["bottom"]) {
        offset += specialOffsets["bottom"][bed];
      }
      if (legH in legOffsets[bed]) {
        offset += legOffsets[bed][legH];
      }
      break;
    }

    case "ottoman": {
      offset = calculateBaseOffset(bed, legH, bedOffsets, legOffsets);
      offset = Math.max(-2, offset - 5);
      break;
    }

    case "headboard": {
      if (bed in specialOffsets["bottom"] && legH in legOffsets[bed]) {
        offset += specialOffsets["bottom"][bed] + legOffsets[bed][legH];
      }
      break;
    }
  }

  return offset;
};

const Stage = ({ selected }) => {
  return (
    <StageWrapper
      id="main-stage"
      background={selected.background?.img}
    >
      {selected.legs?.id && (
        <RenderLegs selected={selected} type="shadow" />
      )}
      
      {selected.headboards && selected.textiles?.hid && (
        <RenderHeadboard
          selected={selected}
          offset={selected.headboards.on_floor ? 0 : get_offsets(selected, "headboard")}
        />
      )}

      {selected.addons && (
        <>
          {selected.addons.map((addon, i) => (
            <RenderAddOn
              key={`addon-back-${i}`}
              selected={selected}
              type="image_2"
              index={i}
              offset={get_offsets(selected, "table")}
            />
          ))}
        </>
      )}

      {selected.bedsidetable && (
        <RenderTable
          selected={selected}
          offset={selected.bedsidetable.on_floor ? 0 : get_offsets(selected, "table")}
          placement="back"
        />
      )}

      {selected.legs?.id && <RenderLegs selected={selected} />}
      
      {selected.textiles && (
        <SafeImage
          src={selected.textiles.img}
          alt={`textile-${selected.textiles.id}`}
          offset={get_offsets(selected, "bed")}
        />
      )}

      {selected.addons && (
        <RenderAddOn
          selected={selected}
          type="sub_mat"
          offset={get_offsets(selected, "pocket")}
        />
      )}
      {selected.topper && (
        <RenderTopper
          selected={selected}
          offset={get_offsets(selected, "topper")}
        />
      )}
      {selected.addons && (
        <>
          {selected.addons.map((addon, i) => (
            <RenderAddOn
              key={`addon-front-${i}`}
              selected={selected}
              type="image"
              index={i}
              offset={get_offsets(selected, "table")}
            />
          ))}
        </>
      )}
      {selected.bedsidetable && (
        <RenderTable
          selected={selected}
          offset={selected.bedsidetable.on_floor ? 0 : get_offsets(selected, "table")}
          placement="front"
        />
      )}
      {selected.ottoman && (
        <RenderOttoman
          selected={selected}
          offset={get_offsets(selected, "ottoman")}
        />
      )}
    </StageWrapper>
  );
};

export { Stage };
